import { AppRole } from '../../models/roles/app-role.model';
import { AppModule } from '../../models/roles/app-module.model';

export interface IRoleState {
    roles: AppRole[];
    selectedRole: AppRole | null;
    modules: AppModule[];
    loading: boolean;
    error: string | null;
}

export const initialRoleState: IRoleState = {
    roles: [],
    selectedRole: null,
    modules: [],
    loading: false,
    error: null,
};
